import slice from "./footfallSlice";

export default slice.reducer;
